import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { CommonStyles } from '../../../../common/react/CommonStyles';

export const textFieldStyles = style({
  marginTop: '16px',
  width: '100%'
});

export const checkboxContainerStyle = {
  marginLeft: '0px',
  marginTop: '8px'
};

export const dialogLabelStyles = {
  color: TabStyles.Typography!.Color!.Primary
};

export const dataGridContainerStyle = style({
  borderBottom: `1px solid ${TabStyles.Colors.L6}`,
  marginBottom: '16px'
});

export const dataGridStyle: React.CSSProperties = {
  overflow: 'hidden',
  padding: '0px',
  marginTop: `${CommonStyles.Sizes.LineHeight}px`,
  zIndex: 'auto',
  height: 305
};